import React, { useState, useEffect } from 'react';
import { auth, db } from '../firebase';
import { doc, getDoc, updateDoc, collection, query, where, getDocs } from 'firebase/firestore';
import QuestionOfTheDay from './QuestionOfTheDay'; // Import the new component
import './Home.css';

const Home = () => {
    const [user, setUser] = useState(null);
    const [partnerEmail, setPartnerEmail] = useState('');
    const [error, setError] = useState('');
    const [success, setSuccess] = useState('');
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const currentUser = auth.currentUser;
        if (currentUser) {
            const userDocRef = doc(db, 'users', currentUser.uid);
            getDoc(userDocRef).then(docSnap => {
                if (docSnap.exists()) {
                    setUser(docSnap.data());
                }
                setLoading(false);
            });
        } else {
            setLoading(false);
        }
    }, []);

    const handleLinkAccount = async () => {
        setError('');
        setSuccess('');
        if (!partnerEmail) {
            setError("Please enter your partner's email.");
            return;
        }

        const usersRef = collection(db, 'users');
        const q = query(usersRef, where("email", "==", partnerEmail));

        try {
            const querySnapshot = await getDocs(q);
            if (querySnapshot.empty) {
                setError("No user found with that email.");
                return;
            }

            const partnerDoc = querySnapshot.docs[0];
            const partnerId = partnerDoc.id;
            const currentUserRef = doc(db, 'users', auth.currentUser.uid);

            await updateDoc(currentUserRef, { partnerId: partnerId });
            
            // Also link partner to current user
            const partnerUserRef = doc(db, 'users', partnerId);
            await updateDoc(partnerUserRef, { partnerId: auth.currentUser.uid });


            setSuccess("Successfully linked with your partner! The app will now reload.");
            setUser({ ...user, partnerId: partnerId });
            setPartnerEmail('');
            
            // Reload to ensure all components get the updated partner info
            setTimeout(() => window.location.reload(), 2000);

        } catch (err) {
            setError("Failed to link accounts. Please try again.");
            console.error(err);
        }
    };
    
    if (loading) {
        return <div className="home-container"><h1>Loading...</h1></div>;
    }

    return (
        <div className="home-container">
            {user && user.partnerId ? (
                <>
                    <h1>Welcome, {user.nickname}</h1>
                    <QuestionOfTheDay />
                    {/* You can add more home-screen components here */}
                </>
            ) : (
                <>
                    <h1>Welcome to Our Secret Garden</h1>
                    <div className="link-account-section">
                        <h2>Link with your Partner</h2>
                        <p>Enter your partner's email address to connect your accounts and start your garden.</p>
                        <input
                            type="email"
                            value={partnerEmail}
                            onChange={(e) => setPartnerEmail(e.target.value)}
                            placeholder="Partner's email"
                        />
                        <button onClick={handleLinkAccount}>Link Account</button>
                        {error && <p className="error-message">{error}</p>}
                        {success && <p className="success-message">{success}</p>}
                    </div>
                </>
            )}
        </div>
    );
};

export default Home;
